"use client";

import { X } from "lucide-react";
import { useEffect } from "react";
import "./enterprise-form-modal.css";


export function ContactSalesModal({ open, onOpenChange }) {
	useEffect(() => {
		if (!open) return undefined;

		const previousOverflow = document.body.style.overflow;
		document.body.style.overflow = "hidden";

		const handleEscape = (event) => {
			if (event.key === "Escape") {
				onOpenChange(false);
			}
		};

		window.addEventListener("keydown", handleEscape);

		return () => {
			document.body.style.overflow = previousOverflow;
			window.removeEventListener("keydown", handleEscape);
		};
	}, [open, onOpenChange]);

	if (!open) return null;

	return (
		<div
			role="dialog"
			aria-modal="true"
			aria-label="Contact Sales Form"
			className="r2-enterprise-form-modal"
			onMouseDown={(event) => {
				if (event.target === event.currentTarget) {
					onOpenChange(false);
				}
			}}
		>
			<div className="r2-enterprise-form-modal__panel">
				<button
					type="button"
					className="r2-enterprise-form-modal__close"
					onClick={() => onOpenChange(false)}
					aria-label="Close form"
				>
					<X className="r2-enterprise-form-modal__close-icon" />
				</button>
				<iframe
					src="https://api.leadconnectorhq.com/widget/form/xKnZuGSYBnLlVk3UCBqX"
					className="r2-enterprise-form-modal__iframe"
					title="RentID Lead Capture Form"
				/>
			</div>
		</div>
	);
}
